const ORG_PREFIX_EXCLUDED_SEGMENTS = new Set([
  'auth',
  'org',
  'account-dashboard',
  'onboarding',
  'not-found',
  'access-denied',
  'clients',
  'vendors',
  'privacy-policy',
  'tos',
  'github',
  'maintenance',
  'license'
]);

export const getFirstPathSegmentFromUrl = (url: string): string | null => {
  const normalizedUrl = url.startsWith('/') ? url.slice(1) : url;
  const firstSegment = normalizedUrl.split(/[/?#]/, 1)[0]?.split(';', 1)[0] ?? '';

  return firstSegment || null;
};

export const shouldPrefixWithActiveOrgSegment = (segment?: string | null): boolean => {
  if (!segment) return false;
  if (segment.startsWith('(')) return false;

  return !ORG_PREFIX_EXCLUDED_SEGMENTS.has(segment);
};
